/* unplugin-vue-components disabled */import script from "./CopyrightProtection.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyrightProtection.vue?vue&type=script&setup=true&lang=js"

import "./CopyrightProtection.vue?vue&type=style&index=0&id=1d6f02e5&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6f02e5"]])

export default __exports__